import ReactEChartsCore from 'echarts-for-react/lib/core';
import type ReactEChartsCoreType from 'echarts-for-react/lib/core';
import type { EChartsOption } from 'echarts';
import { LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import {
  breakpointsMediaQuery,
  getColor,
  tooltipFormatter,
  useMediaQuery
} from '@/helpers/utils';
import { Card } from 'react-bootstrap';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { useRef } from 'react';
import CardChartDropDown from '@/components/common/CardChartDropDown';
import { crawlTooltip } from '@/app/Crawl/tooltip/crawlTooltips';
import { useTooltipHide } from '@/hooks/useTooltipHide';
echarts.use([LineChart, TooltipComponent, GridComponent, LegendComponent]);
// نمودار پیوند های خارجی
type ChartRow = {
  name?: string;
  value?: number | string;
};

type ChartDataResponse = {
  data?: ChartRow[];
};

type ExternalLinksChartProps = {
  data?: ChartDataResponse;
};

const ExternalLinksChart = ({ data }: ExternalLinksChartProps) => {
  const cardRef = useRef<HTMLDivElement | null>(null);
  const chartRef = useRef<ReactEChartsCoreType | null>(null);
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  useTooltipHide(chartRef);

  const formattedBar = (data?.data ?? []).map(
    (row: ChartRow) => row?.name
  );
  const formattedData = (data?.data ?? []).map(
    (row: ChartRow) => row?.value
  );

  // تنظیمات نمودار
  const getOption = (): EChartsOption => ({
    textStyle: {
      fontFamily: 'dana'
    },
    tooltip: {
      triggerOn: isMdUp ? 'mousemove' : 'click',
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('gray-1100') },
      borderWidth: 1,
      formatter: tooltipFormatter,
      transitionDuration: 0,
      axisPointer: {
        type: 'none'
      }
    },
    xAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'solid'
        }
      },
      axisTick: { show: false },
      axisLabel: {
        color: getColor('gray-800'),
        formatter: (value: string | number) => value,
        margin: 15
      },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      data: formattedBar.reverse(),
      type: 'category',
      axisLabel: {
        show: true,
        color: getColor('gray-800'),
        margin: 15
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: getColor('gray-200')
        }
      },
      axisTick: { show: false },
      axisLine: { show: false }
    },
    series: [
      {
        type: 'bar',
        name: 'پیوند خارجی',
        data: formattedData.reverse(),
        lineStyle: { color: getColor('primary') },
        itemStyle: {
          color: getColor('primary'),
          borderRadius: [0, 3, 3, 0]
        },
        showSymbol: false,
        symbol: 'circle',
        smooth: false,
        emphasis: {
          scale: true
        }
      }
    ],
    grid: { right: '3%', left: '150px', bottom: '10%', top: '5%' }
  } as unknown as EChartsOption);

  return (
    <Card className="mb-3" ref={cardRef}>
      <FalconCardHeader
        title={
          <div>
            پیوند خارجی خزش{' '}
            <HelpTooltip html={crawlTooltip.crawlerExternalLinls.chart} />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
      />
      <Card.Body className="px-3 text-center">
        <ReactEChartsCore
          ref={chartRef}
          echarts={echarts}
          option={getOption()}
          style={{ height: '23rem' }}
        />
      </Card.Body>
    </Card>
  );
};
export default ExternalLinksChart;
